import { I as r } from "../../constants-DeVuDy8J.js";
import { openBlock as d, createElementBlock as n, normalizeClass as s, createElementVNode as e } from "vue";
import { _ as o } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconMaestro",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (t) => Object.keys(r).includes(t)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return r[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, f = ["aria-label", "data-qa", "aria-hidden"];
function u(t, i, l, m, _, a) {
  return d(), n("svg", {
    "aria-label": l.ariaLabel,
    class: s([a.iconSizeClass, "d-icon d-icon--maestro"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "Maestro",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, [...i[0] || (i[0] = [
    e("rect", {
      x: ".25",
      y: "3.75",
      width: "23.5",
      height: "16.5",
      rx: "1.75",
      fill: "#fff",
      stroke: "#E3E5E8",
      "stroke-width": ".5"
    }, null, -1),
    e("path", {
      d: "M13.358 11.733c0 2.615-2.095 4.734-4.679 4.734S4 14.347 4 11.734C4 9.118 6.095 7 8.68 7c2.583 0 4.678 2.12 4.678 4.733Z",
      fill: "#ED0006"
    }, null, -1),
    e("path", {
      d: "M19.429 11.733c0 2.615-2.095 4.734-4.68 4.734-2.584 0-4.679-2.12-4.679-4.733C10.07 9.118 12.165 7 14.75 7c2.584 0 4.679 2.12 4.679 4.733Z",
      fill: "#0099DF"
    }, null, -1),
    e("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M11.714 8.13a4.745 4.745 0 0 1 1.644 3.603 4.745 4.745 0 0 1-1.644 3.603 4.745 4.745 0 0 1-1.644-3.603c0-1.442.638-2.734 1.644-3.602Z",
      fill: "#6C6BBD"
    }, null, -1)
  ])], 10, f);
}
const E = /* @__PURE__ */ o(c, [["render", u]]);
export {
  E as default
};
//# sourceMappingURL=maestro.js.map
